import { Stack, Tooltip, Typography } from '@mui/material'
import { C1Icon } from 'components/core/icons/C1Icon'
import { Zap } from 'lucide-react'
import { FormattedMessage } from 'react-intl'
import { TaskTypeStyles } from './styles'

export const ActionTaskComponent: React.FC = () => (
    <Stack direction="row" spacing={1} alignItems="center" sx={TaskTypeStyles.container}>
        <C1Icon icon={Zap} sx={TaskTypeStyles.actionIcon} size="sm" />
        <Typography>
            <FormattedMessage id="task_type_action" defaultMessage="Action" />
        </Typography>
    </Stack>
)

export const ActionTaskIcon: React.FC = () => (
    <Tooltip title={<FormattedMessage id="task_type_action" defaultMessage="Action" />} placement="top">
        <C1Icon icon={Zap} sx={TaskTypeStyles.actionIcon} size="sm" />
    </Tooltip>
)
